import { render, staticRenderFns } from "./MyFooter3.vue?vue&type=template&id=0fa6fb6e&scoped=true"
import script from "./MyFooter3.vue?vue&type=script&lang=js"
export * from "./MyFooter3.vue?vue&type=script&lang=js"
import style0 from "./MyFooter3.vue?vue&type=style&index=0&id=0fa6fb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6fb6e",
  null
  
)

export default component.exports